<template>
  <div class="recommended-brand">
    <!-- 头部登录 -->
    <header-top></header-top>
    <!-- 头部搜索和tabs -->
    <header-search></header-search>
    <div class="main w">
      <div class="main-top clearfix">
        <img
          class="fl"
          src="https://img.g-part.cn/test/oms/2021/12/20/16399914489356392.png"
          alt=""
        />
        <Button class="fr" size="large" @click="EnterStore">进入旗舰店</Button>
      </div>
      <div class="main-bottom">
        <img
          src="https://img.g-part.cn/test/oms/2021/12/20/16399912819445596.png"
          alt=""
        />
        <img
          src="https://img.g-part.cn/test/oms/2021/12/20/16399912672214967.png"
          alt=""
        />
        <img
          src="https://img.g-part.cn/test/oms/2021/12/20/16399912460217636.png"
          alt=""
        />
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// import footer from '../base/common/footer.vue'
import Footer from '../base/common/footer.vue'
import headerTop from '../base/common/header-top.vue'
import headerSearch from '../base/common/header-search.vue'
export default {
  name: 'recommended-brand',
  components: { headerTop, headerSearch, Footer },
  data() {
    return {
      // searchContent：
    }
  },
  created() {},
  methods: {
    // 进入店铺
    EnterStore() {
      this.$router.push({
        path: '/homePage',
        query: {
          tenantId: sessionStorage.getItem('tenantId'),
          shopId: sessionStorage.getItem('shopId')
        }
      })
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang='less' scoped>
.recommended-brand {
  .w {
    width: 1200px;
    margin: 0 auto;
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .clearfix {
    overflow: hidden;
    _zoom: 1;
  }
  .main {
    margin-top: 40px;
    // height: 850px;
    // overflow-y: auto;
    .main-top {
      margin-bottom: 20px;
      padding: 0 10px;
      img {
        width: 113px;
        height: 25px;
      }
      .ivu-btn-large {
        height: 40px;
        padding: 8px 40px;
        font-size: 16px;
        border-radius: 6px;
        background: #e90d0d;
        color: #ffffff;
        font-size: 14px;
      }
      .ivu-btn-large:hover {
        border: 0;
        transform: 0;
      }
    }
    .main-bottom {
      img {
        width: 100%;
      }
    }
  }
}
</style>